module.exports = __webpack_public_path__ + "img/hrm-judith-lg.b438a68.png";